import React, { Component } from 'react';
import { connect } from 'react-redux';
import { GymEnvironment } from 'fitbeat.models';
import { translate } from 'react-i18next';
import { UserServiceClient } from 'fitbeat.api-clients';
import { SignupFlowType } from 'fitbeat.gym-core';
import { AccountType, RemoteConfigVariables } from 'fitbeat.models';
import { ButtonTypes, ButtonSize } from 'fitbeat.react-native-components';
import {
  StyleSheet, View,
  Dimensions, StatusBar,
} from 'react-native';
import { State, TapGestureHandler } from 'react-native-gesture-handler';
import { ENVIRONMENT, getUrls } from '../config';
import { DevToggles } from './components/devToggles';

import { GoogleAnalytics } from '../services/google-analytics';
import { getApiConfig } from '../config/index';
import { clearSignupError, getSignupFlowScreens } from './actions';
import { FirebaseConfigButton } from '../ui';
import Theme from '../theme';
import { defaultScale } from '../utils/scaling';
import { showMessage, StatusBarComponent } from '../ui/components';
import { WelcomeImageSlider } from './WelcomeImageSlider'
import { shouldNavigateToEliteOnBoardingSelector } from './auth-selectors';
import { openLink } from '../utils/linkUtils';

const TOGGLE_GESTURE = {
  fingers: __DEV__ ? 2 : 3,
  numberOfTaps: 4,
};

const width = Dimensions.get('window').width

class Welcome extends Component {
  googleAnalytics = new GoogleAnalytics();

  constructor(props) {
    super(props);
    this.googleAnalytics.setCurrentScreen('Welcome', 'Welcome');
    this.props.getSignupFlowScreens(SignupFlowType.TypeOne);
    this.state = {
      header: ' ',
      text: `Gym smart with Australia's home fitness revolution`,
    }
  }

  componentDidMount = () => {
    this.handleNavigateToAuthScreen();
  };

  componentDidUpdate = async (prevProps) => {
    const { wasDeepLink, continueSignupToken, signupError, influencerId } = this.props;

    if (!prevProps.signupError && signupError) {
      showMessage(signupError);
      this.props.clearSignupError();
    }

    const shouldNavigateToInfluencerSchedule = influencerId && influencerId !== prevProps.influencerId;

    const shouldNavigate =
      (continueSignupToken && prevProps.continueSignupToken !== continueSignupToken) ||
      (wasDeepLink && prevProps.wasDeepLink !== wasDeepLink) || shouldNavigateToInfluencerSchedule;
    if (shouldNavigate) {
      this.handleNavigateToAuthScreen();
    }
  }

  handleNavigateToAuthScreen = () => {
    // Todo: use preAuthRouteSelector for this navigation
    const { wasDeepLink, loginWithToken, accountType, workoutInviteId, invitationCode, shouldNavigateToEliteOnBoarding,
      influencerId, continueSignupToken, route, specialOfferId } = this.props;
     if (wasDeepLink) {
       if (route === 'subscription' && specialOfferId) {
         this.props.navigation.navigate('PreAuthPayment');
         return;
       }
      if (influencerId){
        this.props.navigation.navigate('InfluencerContainer');
        return
      }
      if (loginWithToken) {
        this.showSignupButtons();
        return;
      }
      if (shouldNavigateToEliteOnBoarding) {
        this.props.navigation.navigate('CreateEliteAccount');
        return;
      }
      if (invitationCode) {
        this.props.navigation.navigate('InvitationCodeSignup');
        return;
      }
      if (continueSignupToken) {
        return this.props.navigation.navigate('PreAccountSetPassword')
      }
      if (workoutInviteId) {
        return this.props.navigation.navigate('InviteToWorkout');
      }
      return;
    }
  }

  login = () => {
    this.props.navigation.navigate('Login');
  }

  seeMembershipPlans = () => {
    const { MEMBERSHIP_PLANS } = getUrls();
    openLink(MEMBERSHIP_PLANS);
  }

  _onGestureHandlerTapEvent = e => {
    if (e.nativeEvent.state !== State.ACTIVE) {
      return;
    }

    ENVIRONMENT.toggled = true;
    this.setState({});
  };

  buildDevToggles = () => {
    const onChange = () => {
      // force re-draw
      this.setState({});
    };

    return (
      <View style={styles.environmentSelector}>
        <DevToggles onChange={onChange}>
        </DevToggles>
      </View>
    );
  };

  getStartedPressed = () => {
    this.props.navigation.navigate('CaptureEmail');
  }

  showSignupButtons = async () => {
    this.setState({
      socialSignupButtonsVisible: true,
    });
  }

  hideSignupButtons = async () => {
    this.setState({
      socialSignupButtonsVisible: false,
    });
  }

  render() {
    const { t } = this.props;
    const inviterImageSource = this.props.navigation.getParam('inviterImageSource')
    return (
      <>
      <StatusBarComponent barStyle='light-content'/>
      <TapGestureHandler
        onHandlerStateChange={this._onGestureHandlerTapEvent}
        minPointers={TOGGLE_GESTURE.fingers}
        numberOfTaps={TOGGLE_GESTURE.numberOfTaps}>
        <View style={styles.container}>
          <WelcomeImageSlider t={t} inviterImageSource={inviterImageSource} />
          {ENVIRONMENT.toggled ? this.buildDevToggles() : null}
          <View style={styles.footer}>
            <FirebaseConfigButton
              onPress={this.getStartedPressed}
              remoteConfigKey={RemoteConfigVariables.welcome_screen_register_button}
              containerStyle={styles.buttonStyle}
              buttonType={ButtonTypes.NORMAL}
              size={ButtonSize.MEDIUM}
              fontColor={Theme.WHITE}
              overrideFontStyles={styles.buttonTextStyle}
            />
          </View>
        </View>
      </TapGestureHandler>
      </>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Theme.WHITE,
  },
  slideContainer: {
    width,
    height: '100%',
  },
  logo: {
    width: defaultScale(180),
    height: defaultScale(70),
    resizeMode: 'contain',
  },
  footer: {
    padding: defaultScale(15),
    alignItems: 'center',
  },
  environmentSelector: {
    paddingHorizontal: 15,
    backgroundColor: Theme.GREY,
  },
  buttonStyle: {
    marginVertical: 5,
    maxWidth: defaultScale(410),
    width: '100%',
    backgroundColor: Theme.BLACK,
    borderColor: Theme.BLACK,
  },
  buttonTextStyle: {
    fontFamily: Theme.Custom700,
  },
  headerText: {
    paddingTop: defaultScale(20),
  },
  headerContainer: {
    justifyContent: 'center',
    height: defaultScale(70),
  },
  descriptionText: {
    ...Theme.textStyle.bodyCopyReg,
    textAlign: 'center',
    marginTop: defaultScale(10),
  },
  buttonContainer: {
    flex: 1,
    justifyContent: 'flex-end',
  },
  detailContainer: {
    alignItems: 'center',
    paddingHorizontal: defaultScale(25),
    marginVertical: defaultScale(20),
  },
});

const mapStateToProps = (state) => {
  const { wasDeepLink, loginWithToken, continueSignupToken, accountType, workoutInviteId, invitationCode, influencerId,
  route, specialOfferId} = state.deepLinkParamaters;
  const { signupError } = state.auth.initialUserSetup;
  const shouldNavigateToEliteOnBoarding = shouldNavigateToEliteOnBoardingSelector(state);
  return {
    accountType,
    wasDeepLink,
    loginWithToken,
    workoutInviteId,
    continueSignupToken,
    signupError,
    shouldNavigateToEliteOnBoarding,
    invitationCode,
    influencerId,
    route,
    specialOfferId,
  };
};

const mapDispatchToProps = (dispatch) => {
  const userProfileService = new UserServiceClient(getApiConfig(), fetch, console.log, undefined);
  return {
    getSignupFlowScreens: (signupFlowType) =>
      dispatch(getSignupFlowScreens(userProfileService, signupFlowType)),
    clearSignupError: () => dispatch(clearSignupError),
  };
};

Welcome = connect(mapStateToProps, mapDispatchToProps)(Welcome);
export default translate(['auth'], { wait: true })(Welcome)
